<template>
  <a-modal
    :title="setVisitTit"
    :visible="visible"
    :confirm-loading="confirmLoading"
    :centered="true"
    :mask-closable="false"
    :ok-text="okTTxt"
    :cancel-text="cancelTxt"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <a-form :form="form">
      <div class="date-item clearfix">
        <a-form-item class="fl">
          <a-date-picker
            v-if="time"
            v-decorator="['date', {
              rules: [{ required: true, message: timePlace}],
              initialValue: moment(date, 'YYYY-MM-DD')
            }]"
            @change="onChangeDate"
          />
          <a-date-picker
            v-else
            v-decorator="['date', {
              rules: [{ required: true, message: timePlace}],
            }]"
            @change="onChangeDate"
          />
        </a-form-item>
        <a-form-item class="fl">
          <a-time-picker
            v-if="time"
            v-decorator="['time', {
              rules: [{ required: true, message: timeNeed}],
              initialValue: moment(time, 'HH:mm')
            }]"
            popup-class-name="remind-time-picker"
            format="HH:mm"
            :open.sync="timeOpen"
            @change="onChangeTime"
          >
            <a
              slot="addon"
              size="small"
              type="primary"
              style="margin-left: 20px;"
              @click="handleCloseTime"
            >
              {{ $t('message["915"]') }}
            </a>
          </a-time-picker>
          <a-time-picker
            v-else
            v-decorator="['time', {
              rules: [{ required: true, message: timeNeed}]
            }]"
            popup-class-name="remind-time-picker"
            format="HH:mm"
            :open.sync="timeOpen"
            @change="onChangeTime"
          >
            <a
              slot="addon"
              size="small"
              type="primary"
              style="margin-left: 20px;"
              @click="handleCloseTime"
            >
              {{ $t('message["915"]') }}
            </a>
          </a-time-picker>
        </a-form-item>
      </div>
      <a-form-item>
        <a-textarea
          v-decorator="['content', {
            rules: [{ required: true, message: contentNeedTip}],
            initialValue: content
          }]"
          :placeholder="contentplace"
          :rows="5"
        />
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import { mapActions } from 'vuex'
import moment from 'moment'

export default {
  props: {
    data: {
      type: Object,
      default: () => { }
    },
    visible: {
      type: Boolean,
      default: false
    },
    inquiryId: {
      type: [String, Number],
      default: () => { }
    }
  },
  data () {
    return {
      isVisible: false,
      confirmLoading: false,
      form: this.$form.createForm(this),
      newData: Object.assign({}, this.data),
      dateTime: '',
      timeOpen: false
    }
  },
  computed: {
    date () {
      const { time = '' } = this.newData || {}
      return time.split(' ')[0]
    },
    time () {
      const { time = '' } = this.newData || {}
      return time.split(' ')[1]
    },
    content () {
      const { content = '' } = this.newData || {}
      return content
    },
    contentNeedTip () {
      return this.$t('message["661"]')
    },
    contentplace () {
      return this.$t('message["778"]')
    },
    cancelTxt () {
      return this.$t('message["896"]')
    },
    okTTxt () {
      return this.$t('message["915"]')
    },
    timePlace () {
      return this.$t('message["943"]')
    },
    setVisitTit () {
      return this.$t('message["1027"]')
    },
    timeNeed () {
      return this.$t('message["1070"]')
    }
  },
  watch: {
    visible: {
      handler (val) {
        if (val) {
          this.newData = Object.assign({}, this.data)
        }
      },
      immediate: true
    }
  },
  methods: {
    moment,
    ...mapActions('inquery/detailData', ['inquiryAddRemind']),
    hide () {
      this.$emit('update:visible', false)
    },
    onChangeDate (date, dateString) {
      // this.date = date
    },
    onChangeTime (time, timeString) {
      // this.time = time
    },
    async handleOk () {
      this.form.validateFieldsAndScroll(async (err, values) => {
        if (!err) {
          if (this.confirmLoading) return

          this.confirmLoading = true

          let content = this.form.getFieldValue('content')
          let date = this.form.getFieldValue('date')
          let time = this.form.getFieldValue('time')

          this.dateTime = moment(date).format('YYYY-MM-DD') + ' ' + moment(time).format('HH:mm')

          const params = {
            inquiryid: this.inquiryId,
            time: this.dateTime,
            content: content
          }

          const chain = await this.inquiryAddRemind(params)
          chain
            .params(params)
            .onNetSuccess(raw => {
              this.confirmLoading = false
              this.handleCancel()
              // eventBus.$emit('fetchInquiryDetail')
            })
            .fetch()
        }
      })
    },
    handleCancel () {
      this.hide()
      this.form.resetFields()
      // this.content = ''
      // this.date = ''
      // this.time = ''
      this.dateTime = ''
      this.confirmLoading = false
    },
    handleCloseTime () {
      this.timeOpen = false
    }
  }
}
</script>

<style lang="scss" scoped>
.date-item {
  margin-bottom: 20px;
  .ant-calendar-picker {
    margin-right: 10px;
  }
}
</style>
<style lang="scss">
.remind-time-picker {
  .ant-time-picker-panel-addon {
    text-align: right;
  }
}
</style>
